// src/utils/windows.js
import { useEffect, useState } from 'react';

/**
 * CSS media query `(max-width: {breakpoint}px)` 와 동일 기준으로
 * 모바일 여부를 판별하는 훅 (JS 전용)
 */
export default function useIsMobile(breakpoint = 768) {
    const [isMobile, setIsMobile] = useState(() => {
        if (typeof window === 'undefined') return false;
        return window.matchMedia(`(max-width: ${breakpoint}px)`).matches;
    });

    useEffect(() => {
        if (typeof window === 'undefined') return;

        const mq = window.matchMedia(`(max-width: ${breakpoint}px)`);

        const handleChange = (e) => {
            setIsMobile(e.matches);
        };

        // 초기 값 동기화
        handleChange(mq);

        mq.addEventListener('change', handleChange);
        return () => mq.removeEventListener('change', handleChange);
    }, [breakpoint]);

    return isMobile;
}
